import React, { FC } from 'react';
import classNames from 'classnames';
import { TypeDecorativeDividerFields } from '@/core/generated-types';
import {
  TW_DECORATIVE_DIVIDER_MARGIN_BOTTOM_CLASSES,
  TW_DECORATIVE_DIVIDER_MARGIN_TOP_CLASSES,
} from '@/core/constants';

export const imageParams = '?fm=webp&q=75';

interface DecorativeDividerProps extends TypeDecorativeDividerFields {
  isHidden?: boolean;
}

const DecorativeDivider: FC<DecorativeDividerProps> = ({
  entryName,
  height = 48,
  backgroundColor,
  dividerImage,
  cropped = false,
  isFullWidth = true,
  id,
  reversed,
  marginTop = '0',
  marginBottom = '0',
  isHidden,
}) => {
  if (isHidden) return null;

  const wrapperClasses = classNames(
    'bg-transparent',
    TW_DECORATIVE_DIVIDER_MARGIN_TOP_CLASSES[marginTop],
    TW_DECORATIVE_DIVIDER_MARGIN_BOTTOM_CLASSES[marginBottom],
    {
      'lg:h-6 h-3.5': height === 24,
      'lg:h-10 h-5': height === 40,
      'lg:h-12 h-6': height === 48,
      'lg:h-16 h-8': height === 64,
    },
  );
  const dividerClasses = classNames(
    {
      'bg-[position:0_-1rem]': cropped,
      'bg-center': !cropped,
      'w-full': isFullWidth,
      'w-[80%]': !isFullWidth,
    },
    'lg:bg-contain bg-cover',
    'bg-repeat-x',
    'h-full',
    'm-0',
    reversed ? `rotate-180` : '',
    backgroundColor ? `bg-${backgroundColor.fields?.color}` : '',
  );

  return (
    <div
      className={wrapperClasses}
      data-testid={`decorative-divider-${entryName}`}
    >
      <div
        className={dividerClasses}
        id={id}
        data-testid={id}
        style={{
          backgroundImage: `url(https:${dividerImage?.fields?.Image?.fields?.file?.url}${imageParams})`,
        }}
      ></div>
    </div>
  );
};

export default React.memo(DecorativeDivider);
